import { IActivityInformationPanel } from "@/interfaces/activityFeed";

//hook
import UseActivityInformationPanel from "./ActivityInformationPanel.hooks";



const ActivityInformationPanel = ({appImageUrl, appName, className = "", time, dateStamp, contentTitle, contentLink, contentExistsInMultiplePlaces = false, likes, comments, recognitionValue, isReply = false, likesEnabled, commentsEnabled}: IActivityInformationPanel) => {
  
    const { info } = UseActivityInformationPanel({
        appImageUrl,
        appName,
        className,
        time,
        dateStamp,
        contentTitle,
        contentLink,
        contentExistsInMultiplePlaces,
        likes,
        comments,
        recognitionValue,
        isReply,
        likesEnabled,
        commentsEnabled,
    });

    if (!info.length) return null;

    return (
        <div className={`user-activity-information-panel ${className}`} data-testid="activity-information-panel" >
            {info.map((item, index) => (
                <span className="user-activity-item" key={`info-${index}`}>
                    {index > 0 && <span className="mid-dot">·</span>}
                    {item}
                </span>
            ))}
        </div>
    );
};

export default ActivityInformationPanel;